export default __webpack_public_path__ + "static/media/doc01.410c56f7.svg";